import type { ReactNode } from 'react';

import { HotelOffersContext } from './contexts/HotelOffersContext';
import useHotelOffersStore from './stores/useHotelOffersStore';

import type {
  Filter,
  PriceRange,
} from '@shared/types/frontend/ubff/hotel-detail-price';
import type { UBFFGateway } from '@shared/types/frontend/ubff-gateway';
import type { I18nService } from '@shared/types/i18n';
import type { UserContext } from '@shared/types/user-context';
import type { Nullable, Stay } from '@shared/types/utils';

import { withUBFFContext } from '@shared/data-access-frontend/contexts/ubff-context';

const HotelOffersProvider = ({
  children,
  dayViewCorrelationId,
  entityId,
  hotelId,
  i18n,
  initialFilters,
  initialPriceType,
  isSeoTraffic,
  priceRanges,
  searchId,
  stay,
  uBFFGateway,
  userContext,
}: {
  children: ReactNode;
  hotelId: string;
  entityId?: string;
  searchId?: string;
  dayViewCorrelationId?: string;
  stay: Stay;
  uBFFGateway: UBFFGateway;
  isSeoTraffic: boolean;
  initialPriceType: Nullable<string>;
  initialFilters?: Filter[];
  priceRanges?: PriceRange[];
  i18n: I18nService;
  userContext: UserContext;
}) => {
  const store = useHotelOffersStore({
    dayViewCorrelationId,
    entityId,
    hotelId,
    i18n,
    initialFilters,
    initialPriceType,
    isSeoTraffic,
    priceRanges,
    searchId,
    stay,
    uBFFGateway,
    userContext,
  });

  return (
    <HotelOffersContext.Provider value={store}>
      {children}
    </HotelOffersContext.Provider>
  );
};

export default withUBFFContext(HotelOffersProvider);
